import actions from 'src/modules/event/publish/eventPublishActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.PUBLISH_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PUBLISH_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLISH_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLISH_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PUBLISH_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLISH_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};

